(() => {
  function initMobileProductCardGallery(root = document) {
    const galleries = root.querySelectorAll('[data-itc-mobile-card-gallery]');

    galleries.forEach((gallery) => {
      if (gallery.dataset.itcGalleryReady === 'true') return;
      gallery.dataset.itcGalleryReady = 'true';

      const track = gallery.querySelector('.itc-mobile-card-gallery__track');
      const slides = gallery.querySelectorAll('.itc-mobile-card-gallery__slide');

      if (!track || slides.length < 2) return;

      const updateActiveSlide = () => {
        const activeIndex = Math.round(track.scrollLeft / track.clientWidth);
        gallery.dataset.activeSlide = String(Math.max(0, Math.min(activeIndex, slides.length - 1)));
      };

      track.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateActiveSlide);
      }, { passive: true });

      window.addEventListener('resize', updateActiveSlide);

      updateActiveSlide();
      setTimeout(updateActiveSlide, 300);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMobileProductCardGallery();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initMobileProductCardGallery(event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    initMobileProductCardGallery(event.target);
  });
})();
